"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountDataResponseToJSON = exports.AccountDataResponseFromJSONTyped = exports.AccountDataResponseFromJSON = void 0;
function AccountDataResponseFromJSON(json) {
    return AccountDataResponseFromJSONTyped(json, false);
}
exports.AccountDataResponseFromJSON = AccountDataResponseFromJSON;
function AccountDataResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'balance': json['balance'],
        'locked': json['locked'],
        'unlock_height': json['unlock_height'],
        'nonce': json['nonce'],
        'balance_proof': json['balance_proof'],
        'nonce_proof': json['nonce_proof'],
    };
}
exports.AccountDataResponseFromJSONTyped = AccountDataResponseFromJSONTyped;
function AccountDataResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'balance': value.balance,
        'locked': value.locked,
        'unlock_height': value.unlock_height,
        'nonce': value.nonce,
        'balance_proof': value.balance_proof,
        'nonce_proof': value.nonce_proof,
    };
}
exports.AccountDataResponseToJSON = AccountDataResponseToJSON;
//# sourceMappingURL=AccountDataResponse.js.map